
import { endpoints } from "../api"
import { setLoading } from "../../slices/AuthSlice";
import toast from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import {message} from '../../messages/Message'


const {GET_TEAM,UPDATE_TEAM}=endpoints;


export function getTeam(token, page = 1, filter = null,filterType=null) {
  return async (dispatch) => {
 dispatch(setLoading(true))
    try {
      const params = `?page=${page}${filter ? `&search=${filter}` : ''}${filterType ? `&filter_type=${filterType}` : ''}`;
      const url = `${GET_TEAM}${params}`;
        const response = await apiConnector("GET", url, '', { 
            'Authorization': `Bearer ${token}` 
          });
      if (response?.status === 200) {
        dispatch(setLoading(false));
        return response;
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 404) {
        return error.response;
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
      }
    }
  }
}


export function updateTeam(payload,token,id,onClose) {
  return async (dispatch) => {
   dispatch(setLoading(true))
    try {
        const url = `${UPDATE_TEAM}/${id}`;
        const response = await apiConnector("POST", url, payload, { 
            'Authorization': `Bearer ${token}` 
          });
      if (response?.status === 200) {
        dispatch(setLoading(false));
        toast.success(response.data.message)
        onClose();
      }
    } catch (error) {
      dispatch(setLoading(false));
      if (error?.response?.status === 422) {
        toast.error(error.response.data.message)
        onClose();
      }
      if (error?.response?.status === 403) {
        toast.error(error.response.data.message)
        onClose();
      }
      
      if (error?.response?.status === 500) {
        toast.error(error.response.data.message);
        onClose();
      }
    }
  }
}
